// extracted by mini-css-extract-plugin
export default {"modalCard":"BlockPhotoProcessingFailureModal_modalCard__JapEh","failedPhotos":"BlockPhotoProcessingFailureModal_failedPhotos__z8WmI"};